// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// libraries
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")

// load all js files under javascript/app
function importAll (r) {
  r.keys().forEach(r);
}
importAll(require.context('app/', true, /\.js$/));
importAll(require.context('app/', true, /\.ts$/));

//importAll(require.context("../../packs/stylesheets", true, /\.scss$/));
import "stylesheets/global"

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
